import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const VideoSection = () => {
  const { isEnglish } = useLanguage();
  // French video: https://youtube.com/shorts/tbV2DebZaAQ
  // English video: https://www.youtube.com/watch?v=l-OMe2rsyRk
  const videoId = isEnglish ? 'l-OMe2rsyRk' : 'tbV2DebZaAQ';
  
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Video Container - Clean YouTube embed without annotations */}
        <div className="flex justify-center mb-8">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-slate-900 w-full aspect-video">
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&showinfo=0&iv_load_policy=3&disablekb=0&fs=1`}
              title="Présentation Hurghada Excursions"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              style={{ border: 'none' }}
            />
          </div>
        </div>

        {/* Text below video */}
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            {isEnglish 
              ? 'I live in Hurghada and I personally select the excursions I recommend.'
              : 'Je vis à Hurghada et je sélectionne personnellement les excursions que je recommande.'}
          </p>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed mt-4">
            <span className="text-teal-600 font-semibold">
              {isEnglish ? 'I remain your contact' : 'Je reste votre contact'}
            </span> {isEnglish ? 'before, during and after booking.' : 'avant, pendant et après la réservation.'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
